import {
  StyledErrorDescription,
  StyledErrorTitle,
  StyledErrorWrapper,
  StyledIcon,
} from "./styles";
import type { ReactElement } from "react";
import { navigateTo } from "../../utils/navigate";

const getMessage = (msg: string): ReactElement => {
  if (msg === "AccessToken was not verified" || msg === "Not logged in") {
    return (
      <>
        Please{" "}
        <button
          type="button"
          style={{ textDecoration: "underline" }}
          onClick={() => {
            fetch("/api/v1/auth/logout/")
              .then(() => {
                navigateTo("/authenticate/login");
              })
              .catch(() => {
                console.error("failed to logout the user");
              });
          }}
        >
          relogin
        </button>{" "}
        in order to proceed. You may also need to clear your cookies.{" "}
      </>
    );
  }
  return <>{"Try clicking refresh to correct the issue"}</>;
};

export const ConnectionLost = ({ msg }: { msg: string }): ReactElement => {
  return (
    <StyledErrorWrapper>
      <StyledIcon>🙁</StyledIcon>
      <StyledErrorTitle>Connection Lost</StyledErrorTitle>
      <StyledErrorDescription>{getMessage(msg)}</StyledErrorDescription>
    </StyledErrorWrapper>
  );
};
